const styles = {
  container: {
    "@media screen and  (min-width : 1200px)": {
      height: "134px",
      width: "733px",
      boxSizing: "border-box",
      borderRadius: "8px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
      paddingLeft: "28px",
      paddingTop: "11px",
      paddingBottom: "12px",
      paddingRight: "11px",
      zIndex: 900,
      position: "absolute",
      bottom: "24px",
      left: "calc(50% - 366.5px)",
    },
  },
  smallContainer: {
    "@media screen and  (max-width : 1199px)": {
      height: "110px",
      width: "327px",
      maxWidth: "95%",
      position: "fixed",
      bottom: "72px",
      left: "calc(50% - 150px)",
      boxSizing: "border-box",
      borderRadius: "8px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0 8px 12px 0 rgba(0,0,0,0.2)",
      padding: "0px",
      display: "flex",
      justifyContent: "flex-start",
    },
  },
  background: {
    backgroundColor: "rgba(0,0,0,0.8)",
    width: "100vw",
    height: "100vh",
    position: "fixed",
    zIndex: 1899,
    top: 0,
  },
  headerContainer: {
    height: "30px",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media screen and  (max-width : 1199px)": {
      display: "none",
    },
  },
  footerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    position: "relative",
    bottom: "-3px",
    "@media screen and  (max-width : 1199px)": {
      display: "none",
    },
  },
  title: {
    height: "23px",
    width: (props) => (props.stop.audio ? "47%" : "auto"),
    color: "#051D39",
    fontFamily: "CircularStd",
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "23px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  closeIcon: {
    position: "relative",
    top: "-3px",
    right: "-1px",
  },
  description: {
    height: "67px",
    boxSizing: "border-box",
    flex: 1,
    paddingRight: "10px",
    overflowY: "scroll",
    color: "#6373A4",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "21px",
    display: "inline-block",
  },
  mediaContainer: {
    display: "inline-block",
    height: "80px",
    position: "relative",
    bottom: "8px",
  },
  instagramContainer: {
    height: "100%",
    width: "100px",
    position: "relative",
    marginRight: "5px",
    display: "inline-block",
    cursor: "pointer",
    float: "left",
  },
  imageContainer: {
    "@media screen and  (min-width : 1200px)": {
      display: "none",
    },
    height: "100%",
    width: "100px",
    objectFit: "cover",
  },
  imageTextContainer: {
    height: "28px",
    width: "41px",
    borderRadius: "14px",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageText: {
    height: "20px",
    width: "25px",
    color: "#FFFFFF",
    fontFamily: '"CircularStd"',
    fontSize: "16px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "20px",
  },
  descriptionContainer: {
    "@media screen and  (min-width : 1200px)": {
      display: "none",
    },
    marginTop: "8px",
    marginBottom: "12px",
    marginLeft: "16px",
    overflow: "hidden",
    marginRight: "14px",
  },
  smallTitle: {
    maxWidth: "159px",
    width: "100%",
    color: "#051D39",
    fontFamily: '"CircularStd"',
    fontSize: "14px",
    fontWeight: "500",
    letterSpacing: "0",
    lineHeight: "21px",
    marginBottom: "8px",
    marginTop: "8px",
    display: "inline-block",
    verticalAlign: "top",
    marginRight: "8px",
  },
  smallDescription: {
    "@media screen and  (min-width : 1200px)": {
      display: "none",
    },
    height: "100%",
    maxWidth: "100%",
    color: "#6373A4",
    fontFamily: "CircularStd",
    fontSize: "12px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "17px",
    overflowY: "scroll",
    maxHeight: "53px",
  },
  audioPlayer: {
    "@media screen and  (max-width :327px)": {
      display: "none",
    },
    "@media screen and  (max-width : 1199px)": {
      left: "inherit",
      transform: "translate(0, 0)",
      top: "8px",
      right: "12px",
    },
    position: "absolute",
    transform: "translateX(-50%)",
    left: "50%",
    top: "9px",
  },
  closeScene: {
    cursor: "pointer",
    "&:hover": {
      "& path:nth-child(2)": {
        fill: "#051D39",
      },
    },
  },
};

export default styles;
